import React, { useEffect, useState } from 'react';

import { Flex, Text } from '@chakra-ui/react';
import GoogleMapReact from 'google-map-react';

import { Icon } from 'components';
import mapStyle from 'theme/map';

export default function Locations({ markers, markerFocus }) {
  const [coords, setCoords] = useState(
    {
      lat: markers?.[0]?.latitude ?? -23.56178964762915,
      lng: markers?.[0]?.latitude ?? -46.65593356608675,
    },
  );

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((location) => {
      setCoords({ lat: location.coords.latitude, lng: location.coords.longitude });
    });
  }, []);

  useEffect(() => {
    if (markers?.[markerFocus]?.latitude && markers?.[markerFocus]?.longitude) {
      setCoords({ lat: markers?.[markerFocus]?.latitude, lng: markers?.[markerFocus]?.longitude });
    }
  }, [markers, markerFocus]);
  function Marker({ marker, ...rest }) {
    return (
      <Flex
        {...rest}
        justifyContent="center"
        alignItems="center">
        <Icon
          size="3xl"
          color="primary.default"
          name="map-marker"
        />
        <Text
          color="white.default"
          variant="smallBold"
          position="absolute">
          {marker.order}
        </Text>
      </Flex>
    );
  }
  return (
    <Flex
      shadow="inset 2px 2px 2px rgba(0, 0, 0, 0.15);"
      borderRadius={8}
      overflow="hidden"
      width="100%"
      alignItems="center"
      justifyContent="center"
      height={400}>
      <Flex
        borderRadius={8}
        overflow="hidden"
        width="calc(100% - 4px)"
        height={396}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
          defaultZoom={11}
          defaultCenter={coords}
          center={coords}
          onChange={({ center }) => setCoords(center)}
          yesIWantToUseGoogleMapApiInternals
          options={{
            fullscreenControl: false,
            zoomControl: false,
            styles: mapStyle,
          }}>
          {markers?.map((marker) => (
            <Marker
              lat={marker.latitude}
              lng={marker.longitude}
              marker={marker}
            />
          ))}
        </GoogleMapReact>
      </Flex>
    </Flex>
  );
}
